<template>
  <Nav />
  <div class="w-full">

    <!-- Hero Banner -->
    <div class="w-full">
      <a href="/General">
        <img src="/ecommerce_banner.png" alt="Hero Banner" class="w-full object-cover max-h-96">
      </a>
    </div>

    <!-- Horizontal Scroll Cards -->
    <div class="bg-gray-200 py-2">
      <div
        class="overflow-x-auto whitespace-nowrap pl-2"
        ref="scrollContainer2"
      >
        <div class="mr-2 inline-block bg-white" v-for="item in items" :key="item">
          <a href="/BlueDress">
            <div v-for="value in item.value" :key="value">
              <img v-if="value.attribute.name==='photo'" :src="`https://ecommerce-api.kalkidan.net/${ value.value}`" alt="notfound" class="rounded-md w-36 h-48 object-cover">
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- Sign In Banner (hidden when already logged in) -->
    <div v-if="!isLoggedIn" class="pl-5 pr-5 mt-3 border-b-2 pb-4">
      <div class="font-bold text-lg">Sign in for best experience</div>
      <div class="mt-3">
        <button @click="GotoSignin" class="bg-yellow-300 w-full max-w-sm py-3 rounded-3xl text-lg">Sign in securely</button>
      </div>
      <div class="mt-3">
        <a href="signup" class="text-green-700">Create an account</a>
      </div>
    </div>

    <!-- Welcome Banner (shown when logged in) -->
    <div v-else class="pl-5 pr-5 mt-3 border-b-2 pb-4 flex items-center gap-3">
      <i class="fa-solid fa-circle-check text-green-600 text-xl"></i>
      <div>
        <span class="font-bold text-gray-800">Welcome back, {{ userName }}!</span>
        <span class="text-sm text-gray-500 ml-2">Happy shopping 🛍️</span>
      </div>
    </div>

    <!-- Main Content -->
    <div class="mt-3 px-4 md:px-6 lg:px-8 max-w-screen-xl mx-auto">

      <!-- Section: PCs & Accessories -->
      <div class="mt-2 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Score the top PCs &amp; Accessories</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div>
            <a href="/Desktop">
              <img :src="`https://ecommerce-api.kalkidan.net/${ desktopImage}`" class="rounded-md w-full object-cover aspect-square">
            </a>
            <p class="text-sm mt-1">Desktops</p>
          </div>
          <div>
            <a href="/Laptop">
              <img :src="`https://ecommerce-api.kalkidan.net/${ photoes}`" class="rounded-md w-full object-cover aspect-square">
            </a>
            <p class="text-sm mt-1">Laptops</p>
          </div>
          <div>
            <a href="/HardDrive">
              <img :src="`https://ecommerce-api.kalkidan.net/${ hardDriveImage}`" class="rounded-md w-full object-cover aspect-square">
            </a>
            <p class="text-sm mt-1">Hard Drives</p>
          </div>
          <div>
            <a href="/PCAccessories">
              <img :src="`https://ecommerce-api.kalkidan.net/${ accessoriesImage}`" class="rounded-md w-full object-cover aspect-square">
            </a>
            <p class="text-sm mt-1">PC Accessories</p>
          </div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">See more</a></div>
      </div>

      <!-- Section: Shoes Under $60 -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Shoes Under $60</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Womens"><img src="/bottomcard5.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Women's</p></div>
          <div><a href="/Mens"><img src="/bottomcard6.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Men's</p></div>
          <div><a href="/Girls"><img src="/bottomcard7.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Girl's</p></div>
          <div><a href="/Boys"><img src="/bottomcard8.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Boy's</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">Shop all</a></div>
      </div>

      <!-- Section: Fantastic Finds for Home -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Fantastic Finds for Home</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Kitchen"><img src="/bottomcard9.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Kitchen</p></div>
          <div><a href="/HomeDecore2"><img src="/bottomcard10.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Home Decor</p></div>
          <div><a href="/Dining"><img src="/bottomcard11.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Dining</p></div>
          <div><a href="/SmartHome"><img src="/bottomcard12.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Smart Home</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">See more</a></div>
      </div>

      <!-- Section: Fashion Faves -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Shine brighter with your fashion faves</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Jewelry"><img src="/bottomcard13.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Jewelry</p></div>
          <div><a href="/HandBag"><img src="/bottomcard14.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Handbags</p></div>
          <div><a href="/FootWear"><img src="/bottomcard15.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Footwear</p></div>
          <div><a href="/Beuty"><img src="/bottomcard16.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Beauty</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">See more</a></div>
      </div>

      <!-- Section: Video Games -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Video games &amp; accessories</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Xbox"><img src="/ps4_controller.png" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Xbox controllers</p></div>
          <div><a href="/Nintendo"><img src="/nintendo_switch.png" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Nintendo</p></div>
          <div><a href="/VR"><img src="/vr_headset_neon.png" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">VR headsets</p></div>
          <div><a href="/Ps5"><img src="/gaming_gear.png" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">PS5 accessories</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">Explore now</a></div>
      </div>

      <!-- Section: Beauty / Radiance -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Unveil your radiance</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/HairCare"><img src="/bottomcard21.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Hair Care</p></div>
          <div><a href="/Fragrances"><img src="/bottomcard22.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Fragrances</p></div>
          <div><a href="/Makeup"><img src="/bottomcard23.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Make-up</p></div>
          <div><a href="/SkinCare"><img src="/bottomcard24.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Skin Care</p></div>
        </div>
        <div class="mt-3"><a href="/WomensClothing" class="text-green-700">Shop more</a></div>
      </div>

      <!-- Section: Step into Style -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Step into style</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="WomensClothing"><img src="/bottomcard25.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Women's clothing</p></div>
          <div><a href="/WomensShoes"><img src="/bottomcard26.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Women's shoes</p></div>
          <div><a href="/MensClothing"><img src="/bottomcard27.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Men's clothing</p></div>
          <div><a href="MensShoes"><img src="/bottomcard28.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Men's shoes</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">Shop more</a></div>
      </div>

      <!-- Section: Premium Home -->
      <div class="mt-4 border-b-4 pb-4">
        <div class="font-bold text-lg mb-3">Premium home</div>
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          <div><a href="/Kitchenanddining"><img src="/bottomcard29.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Kitchen &amp; dining</p></div>
          <div><a href="/Furniture"><img src="/bottomcard30.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Furniture</p></div>
          <div><a href="/Bedding"><img src="/bottomcard31.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Bedding</p></div>
          <div><a href="/HomeImprovement"><img src="/bottomcard32.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Home improvements</p></div>
          <div><a href="/Garden"><img src="/bottomcard33.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Garden &amp; outdoors</p></div>
          <div><a href="/Decor"><img src="/bottomcard34.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Decor</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">Shop long-lasting picks</a></div>
      </div>

      <!-- Section: Kids & Baby -->
      <div class="mt-4 border-b-4 pb-4">
        <div class="font-bold text-lg mb-3">Get ready for a day out with your little one</div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <div class="sm:col-span-2 lg:col-span-1">
            <a href="/Snak"><img src="/bottomcard35.jpg" alt="" class="rounded-md w-full object-cover h-48"></a>
            <p class="text-sm mt-1">Snacks &amp; food</p>
          </div>
          <div><a href="/Toys"><img src="/bottomcard36.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Toys</p></div>
          <div><a href="/Strolers"><img src="/bottomcard37.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Strollers</p></div>
          <div><a href="/Car"><img src="/bottomcard38.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Car Seats</p></div>
        </div>
        <div class="mt-3"><a href="" class="text-green-700">Explore more</a></div>
      </div>

      <!-- Section: Tablets -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Tablets under $100</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Tab1"><img src="/bottomcard39.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a></div>
          <div><a href="/Tab2"><img src="/bottomcard40.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a></div>
          <div><a href="/Tab3"><img src="/bottomcard41.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a></div>
          <div><a href="Tab4"><img src="/bottomcard42.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a></div>
        </div>
        <div class="mt-4"><a href="#" class="text-green-700">Shop now</a></div>
      </div>

      <!-- Section: Deals on shoes -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Deals on shoes</div>
        <a href="/DealsOnShoes"><img src="/bottomcard43.jpg" alt="" class="rounded-md w-full max-w-lg object-cover"></a>
      </div>

      <!-- Section: Gaming Merchandise -->
      <div class="mt-4 border-b-4 pb-4">
        <div class="font-bold text-lg mb-3">Gaming merchandise</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/Apparel"><img src="/bottomcard44.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Apparel</p></div>
          <div><a href="/Hats"><img src="/bottomcard45.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Hats</p></div>
          <div><a href="/Action"><img src="/bottomcard46.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Action figures</p></div>
          <div><a href="/Mugs"><img src="/bottomcard47.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Mugs</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">See more</a></div>
      </div>

      <!-- Section: Women's Sneakers -->
      <div class="mt-4 border-b-4 pb-4">
        <div class="font-bold text-lg mb-3">Women's fashion sneakers</div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <div><a href="/WomenShoes1"><img src="/bottomcard48.jpg" alt="" class="rounded-md w-full object-cover aspect-square shadow-md"></a></div>
          <div><a href="WomenShoes2"><img src="/bottomcard49.jpg" alt="" class="rounded-md w-full object-cover aspect-square shadow-md"></a></div>
          <div><a href="WomenShoes3"><img src="/bottomcard50.jpg" alt="" class="rounded-md w-full object-cover aspect-square shadow-md"></a></div>
          <div><a href="WomenShoes4"><img src="/bottomcard51.jpg" alt="" class="rounded-md w-full object-cover aspect-square shadow-md"></a></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">See more</a></div>
      </div>

      <!-- Section: Home & Kitchen Under $30 -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Home &amp; Kitchen Under $30</div>
        <a href="/Homandkitches"><img src="/bottomcard52.jpg" alt="" class="rounded-md w-full max-w-lg object-cover"></a>
      </div>

      <!-- Section: Travel -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Travel Essentials for your next trip</div>
        <a href="/Travel"><img src="/bottomcard53.jpg" alt="" class="rounded-md w-full max-w-lg object-cover"></a>
      </div>

      <!-- Section: Wake Up Happy -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Find new ways to wake up happy</div>
        <a href="/NewWay"><img src="/bottomcard54.jpg" alt="" class="rounded-md w-full max-w-lg object-cover"></a>
      </div>

      <!-- Section: Books -->
      <div class="mt-4 border-b-2 pb-4">
        <div class="font-bold text-lg mb-3">Top Sellers in Books for you</div>
        <div class="space-y-5 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:grid-cols-3">
          <div class="flex gap-4 items-start">
            <a href="/Book1"><img src="/bottomcard55.jpg" alt="" class="h-32 rounded shadow-sm shrink-0"></a>
            <div>
              <p class="text-sm">Hamingain I hullunum: Smasagnasafn (Icelandic Edition)</p>
              <p class="mt-2"><sup>$</sup>33<sup>12</sup></p>
            </div>
          </div>
          <div class="flex gap-4 items-start">
            <a href="/Book2"><img src="/bottomcard56.jpg" alt="" class="h-32 rounded shadow-sm shrink-0"></a>
            <div>
              <p class="text-sm">Les Damnes de la Rente: Pourquoi Le Gabon ne decolle pas (French Edition)</p>
              <p class="mt-2"><sup>$</sup>18<sup>86</sup></p>
            </div>
          </div>
          <div class="flex gap-4 items-start">
            <a href="/Book3"><img src="/bottomcard57.jpg" alt="" class="h-32 rounded shadow-sm shrink-0"></a>
            <div>
              <p class="text-sm">Ethiopia Incorporated: Transforming the Way Businesses Run in Africa</p>
              <p class="mt-2"><sup>$</sup>6<sup>49</sup></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Section: Explore Departments -->
      <div class="mt-4 border-b-4 pb-4">
        <div class="font-bold text-lg mb-3">Explore Departments</div>
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          <div><a href="/Beauty"><img src="/bottomcard58.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Beauty</p></div>
          <div><a href="/Homeandkitchen"><img src="/bottomcard59.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Home and Kitchen</p></div>
          <div><a href="/Sports"><img src="/bottomcard60.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Sports and Outdoors</p></div>
          <div><a href="/Electronics"><img src="/bottomcard61.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Electronics</p></div>
          <div><a href="/Outdoor"><img src="/bottomcard62.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Outdoor Clothing</p></div>
          <div><a href="/Pet"><img src="/bottomcard63.jpg" alt="" class="rounded-md w-full object-cover aspect-square"></a><p class="text-sm mt-1">Pet Supplies</p></div>
        </div>
        <div class="mt-3"><a href="#" class="text-green-700">All Departments</a></div>
      </div>

    </div>

    <!-- Footer -->
    <div>
      <div class="bg-gray-600 text-white text-center py-2 cursor-pointer">
        <div><i class="fa-solid fa-caret-up"></i></div>
        <div class="text-sm">TOP OF PAGE</div>
      </div>
      <div class="bg-gray-800 text-white py-6 px-5">
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 max-w-screen-xl mx-auto">
          <div class="space-y-4 text-sm">
            <a href="" class="block hover:underline">Amazon.com</a>
            <a href="" class="block hover:underline">Your Lists</a>
            <a href="" class="block hover:underline">Registry &amp; Gift List</a>
            <a href="" class="block hover:underline">Your Account</a>
            <a href="" class="block hover:underline">Sell Products on Amazon</a>
            <a href="" class="block hover:underline">Recalls and Product Safety Alerts</a>
            <a href="" class="block hover:underline">Customer Service</a>
          </div>
          <div class="space-y-4 text-sm">
            <a href="" class="block hover:underline">Your Orders</a>
            <a href="" class="block hover:underline">Gift Cards</a>
            <a href="" class="block hover:underline">Find a Gift</a>
            <a href="" class="block hover:underline">Browsing History</a>
            <a href="" class="block hover:underline">Your Returns</a>
          </div>
        </div>
      </div>
      <div class="bg-gray-900 text-white py-8 px-4">
        <div class="flex flex-wrap justify-center gap-6 text-sm">
          <div><i class="fa-solid fa-globe mr-1"></i> English</div>
          <div>$ USD - US Dollar</div>
          <div><img src="/united.jpg" alt="" class="w-6 h-4 inline-block mr-1"> United States</div>
        </div>
        <div class="mt-6 text-center text-sm">
          Already a customer? <a href="" class="underline">Sign in</a>
        </div>
        <div class="mt-4 flex flex-wrap justify-center gap-4 text-xs text-gray-400">
          <a href="">Conditions of Use</a>
          <a href="">Privacy Notice</a>
          <a href="">Consumer Health Data Privacy Disclosure</a>
        </div>
        <div class="text-center text-xs text-gray-400 mt-2">
          Your Ads Privacy Choices <input type="checkbox" class="ml-2">
        </div>
        <div class="text-center text-xs text-gray-500 mt-2">&copy;1996-2024, Amazon.com, Inc. or its affiliates</div>
      </div>
    </div>

  </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import { useEcommerceStore } from '@/stores/Ecommerce';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  components: { Nav },
  data() {
    return {
      items: [],
      values: [],
      photo: [],
      photoes: '',
      laptop: [],
      desktop: [],
      desktopImage: '',
      hardDrives: [],
      hardDriveImage: '',
      accessories: [],
      accessoriesImage: '',
      isLoggedIn: false,
      userName: ''
    };
  },
  mounted() {
    this.setupScrollListeners();
    const EcommerceStore = useEcommerceStore();
    const router = useRouter();
    EcommerceStore.verifyLogin(router);
    this.fetchProducts();
    this.fetchlaptop();
    this.fetchDesktop();
    this.fetchHardDrives();
    this.fetchAccessories();
    // Check login state from localStorage
    this.isLoggedIn = !!localStorage.getItem('token');
    this.userName = localStorage.getItem('user_name') || 'there';
  },
  methods: {
    GotoSignin() {
      this.$router.push('/signin');
    },
    setupScrollListeners() {
      this.$nextTick(() => {
        const scrollContainer2 = this.$refs.scrollContainer2;
        if (!scrollContainer2) return;
        scrollContainer2.addEventListener('wheel', (evt) => {
          scrollContainer2.scrollLeft += evt.deltaY;
        });
      });
    },
    async fetchProducts() {
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/paginatedItem');
      this.items = response.data.item.data;
    },
    async fetchlaptop() {
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/displayLaptop');
      this.laptop = response.data.item.data;
      this.laptop.filter((item) => { this.photo = item.value; this.photoes = this.laptop.map(item => `https://ecommerce-api.kalkidan.net/${item.value}`); });
      this.photo.filter((p) => { this.photoes = p.value; });
    },
    async fetchDesktop() {
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/displayDesktop');
      this.desktop = response.data.item.data;
      this.desktop.filter((item) => { this.photo = item.value; this.desktopImage = this.desktop.map(item => `https://ecommerce-api.kalkidan.net/${item.value}`); });
      this.photo.filter((p) => { this.desktopImage = p.value; });
    },
    async fetchHardDrives() {
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/desplayHardDrivdes');
      this.hardDrives = response.data.item.data;
      this.hardDrives.filter((item) => { this.photo = item.value; this.hardDriveImage = this.hardDrives.map(item => `https://ecommerce-api.kalkidan.net/${item.value}`); });
      this.photo.filter((p) => { this.hardDriveImage = p.value; });
    },
    async fetchAccessories() {
      const response = await axios.get('https://ecommerce-api.kalkidan.net/api/fetchAccessorires');
      this.accessories = response.data.item.data;
      this.accessories.filter((item) => { this.photo = item.value; this.accessoriesImage = this.accessories.map(item => `https://ecommerce-api.kalkidan.net/${item.value}`); });
      this.photo.filter((p) => { this.accessoriesImage = p.value; });
    }
  }
}
</script>

<style scoped>
</style>

